<script setup lang="ts">
import { type PropType, ref } from 'vue'
import 'swiper/css'
import 'swiper/css/thumbs'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { FreeMode, Navigation, Thumbs, Zoom } from 'swiper/modules'
import { testData } from '~/composables/testData'
import type { mediaType } from '~/server/newhouse/interface'

/**
 * 传入数据
 */
defineProps({
  mediaList: {
    type: Array as PropType<mediaType[]>,
    default: () => testData().picList.value,
  },
})
/**
 * 控制弹窗
 */
const show = defineModel('show', { type: Boolean, default: false })

/**
 * swiper组件
 */
const modules = [FreeMode, Navigation, Thumbs, Zoom]

const activeIndex = ref(0)

/**
 * 视频组件指向
 */
const videoRef = ref<any>()

const swiperRef1 = ref<any>()
const swiperRef2 = ref<any>()

function handleShow(slide: number = 0) {
  activeIndex.value = slide
  swiperRef1.value.slideToLoop(slide)
  swiperRef2.value.slideToLoop(slide)
  show.value = true
}

defineExpose({ handleShow })

/**
 * 设置缩略图
 * @param swiper
 */
function setThumbsSwiper(swiper: any) {
  swiperRef2.value = swiper
}

/**
 * 显示视频或VR
 * @param item
 */
function handleShowAlbum(item: mediaType): void {
  if (item.type === 2) {
    videoRef.value.handleShow(item)
  }
}

/**
 * 关闭
 */
function close(): void {
  show.value = false
  videoRef.value.close()
}
</script>

<template>
  <Transition name="fade">
    <div v-show="show" class="desk">
      <CloseOutlined class="icon-close" @click="close()" />
      <Swiper
        :style="{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
          'z-index': 2,
        }"
        :navigation="true"
        :zoom="true"
        :slides-per-view="1"
        class="album-swiper"
        :modules="modules"
        :thumbs="{ swiper: swiperRef2 }"
        :real-index="activeIndex"
        :loop="mediaList.length > 10"
        @swiper="(swiper) => swiperRef1 = swiper"
      >
        <SwiperSlide v-for="(item, index) in mediaList" :key="index">
          <div v-if="(item.type === 2 && item.cover) || (item.type !== 2 && item.url)" class="swiper-zoom-container">
            <img :src="item.type === 2 ? item.cover : item.url" alt="">
          </div>
          <div v-else class="no-cover-bg" />
          <img v-if="item.type === 2" class="video-play" src="@/assets/images/video-play-logo.png" alt="" @click="handleShowAlbum(item)">
        </SwiperSlide>
      </Swiper>
      <Swiper
        :slides-per-view="6"
        class="album-swiper2"
        :free-mode="true"
        :watch-slides-progress="true"
        :modules="modules"
        :real-index="activeIndex"
        @swiper="setThumbsSwiper"
      >
        <SwiperSlide v-for="(item, index) in mediaList" :key="index" class="relative text-center">
          <img v-if="(item.type === 2 && item.cover) || (item.type !== 2 && item.url)" :src="item.type === 2 ? item.cover : item.url" alt="">
          <div v-else class="no-cover-bg" />
          <img v-if="item.type === 2" class="video-play2" src="@/assets/images/video-play-logo.png" alt="">
        </SwiperSlide>
      </Swiper>
      <ClientOnly>
        <lazy-album-video ref="videoRef" />
      </ClientOnly>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.swiper-zoom-container {
  height: 100%;
  width: 100%;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.desk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000000;

  .icon-close {
    font-size: 35px;
    color: #FFFFFF;
    position: absolute;
    right: 55px;
    top: 45px;
    z-index: 10;
  }

  .album-swiper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1000px;
    height: 666px;
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    position: relative;
  }

  .video-play {
    position: absolute;
    width: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .swiper-slide-thumb-active {
    opacity: 1;
  }

  .swiper-slide img {
    //display: block;
    object-fit: cover;
    max-width: 800px;
    max-height: 500px;
    //position: absolute;
    //top: 50%;
    //left: 50%;
    //transform: translate(-50%, -50%);
  }
  .swiper-slide .no-cover-bg {
    display: block;
    width: 800px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #000;
  }
  .album-swiper2 {
    position: absolute;
    bottom: 20px;
    width: 50%;
    margin: 0 auto;
    height: 100px;
    left: 50%;
    transform: translate(-50%, 0);

    //:deep(.swiper-wrapper) {
    //  justify-content: center;
    //}

    :deep(.swiper-slide) {
      opacity: 0.4;
    }

    img {
      width: 100px;
      height: 100px;
    }
    .no-cover-bg{
      width: 100px;
      height: 100px;
      background: #afa8a8;
    }
    .video-play2 {
      position: absolute;
      width: 40px;
      height: 40px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    :deep(.swiper-slide-thumb-active) {
      opacity: 1;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
